const DEVICE_TOKEN = 'AUTH/DEVICE_TOKEN';

export default function deviceTokenAction (identityToken: string, accessToken: string, refreshToken: string, expiresIn: number) {
  return {
    type: DEVICE_TOKEN,
    payload: { 
        identityToken: identityToken,
        accessToken: accessToken,
        refreshToken: refreshToken,
        expiresIn: expiresIn
     }
  };
}

export { DEVICE_TOKEN };